export function getFileIds(formRequest: object): string[] {
  const paths: string[] = Object.values(formRequest);
  const fileIds: string[] = [];
  for (const index in paths) {
    const path = paths[index];

    if (!path) continue;

    const splitPath = path.split('/');

    const lastIndex = splitPath?.length - 1;

    fileIds.push(splitPath[lastIndex]);
  }
  return fileIds;
}

export const isMutationError = (error: boolean) => {
  return error === true;
};
